export default {
  'partner-idpartner-bank': ['partner_bank_management'],
  'partner-idpartner-bank-idbank-edit': ['partner_bank_management', 'partner_bank_edit'],
  'partner-idpartner-document-iddocumentpartner-approve': ['partner_approve_contract'],
  'partner-idpartner-business-opportunity-idbusinessopportunity-replicate': ['partner_business_opportunity_replicate'],
  'partner-idpartner-task-completion-time': ['partner_task_completion_time_management']
}
